import { HeadingTableCell } from "./HeadingTableCell";
import { HeadingTableCellProps } from "./HeadingTableCellProps";
import { ToolsTableCell } from "./ToolsTableCell";

export class ToolsHeadingTableCell extends HeadingTableCell {
    constructor(props?: Partial<HeadingTableCellProps>) {
        super({
            ...props,
            fixedWidth: ToolsTableCell.STARTING_WIDTH,
            paddingLeft: 0, // Padding values are restored when the cell has a non-zero width
            paddingRight: 0,  // Padding values are restored when the cell has a non-zero width
            id: "columnHeaderTools"
        });
    }

    public override get selectableInDesigner(): boolean {
        return false;
    }

    protected override isResizable(): boolean {
        return false;
    }

    override isSerialized(): boolean {
        return false;
    }
}
